import { IFrameMessage } from "./iframe-message";

/**
 * IFrameBrokerService
 * Usage:
 *
 * const iframeBrokerService = new IFrameBrokerService();
 * iframeBrokerService.onMessage(message => {
 *     console.log(message);
 * });
 *
 * iframeBrokerService.sendMessageToIFrame(iframe, { message });
 */
export class IFrameBrokerService {
    private messageHandlers: ((message: IFrameMessage) => void)[] = [];

    constructor() {
        window.addEventListener('message', this.handleMessage.bind(this));
    }

    public sendMessageToIFrame(iframe: Window, message: IFrameMessage): void {
        iframe?.postMessage(message, '*');
    }

    public onMessage(handler: (message: IFrameMessage) => void): void {
        this.messageHandlers.push(handler);
    }

    private handleMessage(event: MessageEvent): void {
        const message: IFrameMessage = event.data;
        this.messageHandlers.forEach(handler => handler(message));
    }
}
